import React from 'react';
import { ToxicDetoxLanding } from './pages/ToxicDetoxLanding';
export function App() {
  return <ToxicDetoxLanding data-id="element-0" />;
}